export default __webpack_public_path__ + "static/media/profile.ba415f3f.jfif";